import { Pipe, PipeTransform } from '@angular/core';
import { format, asYouType } from 'libphonenumber-js';

@Pipe({
    name: 'contactViewPipe',
})
export class contactViewPipe implements PipeTransform {

    transform(number: any, code?: any) {
        if (code) {
            number = format(number, code, 'International');
        }

        let value: any = new asYouType().input(number);
        if (number && (value.length < 5 || value.indexOf(' ') !== -1)) {
            return value;
        } else if (number) {
            number = number.substring(0, number.length - 1);
            value =  new asYouType().input(number);
            return value;
        }
        return null;
    }

    transformNational(number: any, code: any) {
        number = number.replace('+1', '');

        let cleaned = ('' + number.replace(/\D/g, '')).slice(0, 10);
        let formattedVal = cleaned;

        const zip = cleaned.substring(0, 3);
        const middle = cleaned.substring(3, 6);
        const last = cleaned.substring(6, 10);

        if (cleaned.length > 6) {
            formattedVal = `${zip}-${middle}-${last}`;
        } else if(cleaned.length > 3) {
            formattedVal = `${zip}-${middle}`;
        } else if(cleaned.length > 0) {
            formattedVal = `${zip}`;
        }

        return formattedVal;
    }

}